// extracted by mini-css-extract-plugin
export default {"link":"Button_link__wmcQg","invert":"Button_invert__H663I"};